export default "/_next/static/images/charts-ca6b17aa5a11fa37fda9e2603de666bf.webp";